import { useController } from "react-hook-form"
import { InputBase } from "@mui/material"
import { alpha, styled } from "@mui/material/styles"
import InputWrapper from "./InputWrapper"

const CustomInput = styled(InputBase)(({ theme, error, changeDisabledTheme }) => ({
	"label + &": {
		marginTop: theme.spacing(3),
	},
	"& .MuiInputBase-input": {
		borderRadius: 4,
		position: "relative",
		backgroundColor: "var(--color-input-bg)",
		border: "1px solid",
		borderColor: error ? "red" : "var(--color-border-default, #E0E3E7)",
		fontSize: 16,
		width: "100%",
		padding: "12px 14px",
		color: "var(--text-color, inherit)",
		WebkitTextFillColor: "var(--text-color, inherit)",
		transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
		"&::placeholder": {
			color: "var(--text-secondary-color, #999)",
			WebkitTextFillColor: "var(--text-secondary-color, #999)",
			opacity: 1,
		},
		"&:focus": {
			boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
			borderColor: theme.palette.primary.main,
		},
	},
	"& .MuiInputBase-input.Mui-disabled": {
		WebkitTextFillColor: "var(--text-secondary-color)",
		color: "var(--text-secondary-color)",
	},
}))

export default function BasicTextField(props) {
	const { name, control, label, tooltip, inputId, placeholder, autoFocus, disabled = false, numberColumn, changeDisabledTheme, customHandleOnChange = false, required = true } = props

	const {
		field: { ref, value, onChange, ...inputProps },
		fieldState: { error },
	} = useController({
		name,
		control,
	})

	const handleChange = (event) => {
        const newValue = event.target.value;
        if (newValue === '' || (/^\d+$/.test(newValue) && newValue.length <= 4)) {
            onChange(newValue);
        }
    };

	return (
		<InputWrapper inputId={inputId} label={label} tooltip={tooltip} error={error} numberColumn={numberColumn} required={required}>
			<CustomInput 
				placeholder={placeholder} 
				id={inputId} 
				autoFocus={autoFocus} 
				disabled={disabled} 
				{...inputProps} 
				error={!!error} 
				ref={ref} 
				changeDisabledTheme={changeDisabledTheme} 
				value={value}
				onChange={customHandleOnChange ? handleChange : onChange}
        	/>
		</InputWrapper>
	)
}
